import { ThemeProvider } from './ThemeProvider.tsx';
import { QueryProvider } from './QueryProvider.tsx';
import { AuthProvider } from './AuthProvider.tsx';
import { AnalyticsProvider } from './AnalyticsProvider.tsx';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const AppContextProvider = ({ children }: Props) => (
  <ThemeProvider>
    <QueryProvider>
      <AuthProvider>
        <AnalyticsProvider>{children}</AnalyticsProvider>
      </AuthProvider>
    </QueryProvider>
  </ThemeProvider>
);
